import React from 'react';
import DeliveryFilter from '../containers/Expedition/Delivery/LoweringDelivery/Filter/DeliveryFilter';
import DeliveryFilterByPartnumber from '../containers/Expedition/Delivery/LoweringDelivery/Filter/DeliveryFilterByPartnumber';
import DeliveryFilterByCim from '../containers/Expedition/Delivery/LoweringDelivery/Filter/DeliveryFilterByCim';
import DeliveryFilterByOrder from '../containers/Expedition/Delivery/LoweringDelivery/Filter/DeliveryFilterByOrder';

import MissionDeliveryDetail from '../containers/Expedition/Delivery/LoweringDelivery/StartDelivery/Mission/MissionDeliveryDetail';
import OrdersList from '../containers/Expedition/Delivery/LoweringDelivery/StartDelivery/Mission/OrdersList';
import EndCalls from '../containers/Expedition/LinePicking/EndCalls/EndCalls';
import OrderGroupList from '../containers/Expedition/OrderGroup/OrderGroupList';
import OrderGroupListItem from '../containers/Expedition/OrderGroup/OrderGroupListItem';
import ListReportPicking from '../containers/Expedition/ReportPicking/ListReportPicking';

import { PERMISSIONS } from '../utils/constants';
import { getPathApp } from '../utils/util';
import PrivateRoute from './PrivateRoute';

let aux = 0;
const pathurl = getPathApp(window);
const DeliveryRoute = [

    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/startdelivery/order/missions/:idMission`} component={MissionDeliveryDetail} validatePermission={PERMISSIONS.Delivery.Access} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/filter/partnumber`} component={DeliveryFilterByPartnumber} validatePermission={PERMISSIONS.Delivery.Filters} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/filter/cim`} component={DeliveryFilterByCim} validatePermission={PERMISSIONS.Delivery.Filters} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/filter/order`} component={DeliveryFilterByOrder} validatePermission={PERMISSIONS.Delivery.Filters} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/ordersList`} component={OrdersList} validatePermission={PERMISSIONS.Delivery.Access} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/groupList/details`} component={OrderGroupListItem} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/groupList`} component={OrderGroupList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/report`} component={ListReportPicking} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/filter`} component={DeliveryFilter} validatePermission={PERMISSIONS.Delivery.Filters} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loweringDelivery/endCalls`} component={EndCalls} validatePermission={PERMISSIONS.Delivery.Access} />
];

export default DeliveryRoute;
